import { Directive, ElementRef, HostListener, Input, Renderer2, ViewChild, inject, input } from '@angular/core';

@Directive({
  selector: '[scrollToTop]',
  standalone: false
})
export class ScrollToTopDirective {
  myElement: ElementRef = inject(ElementRef);
  scrollToTop? = input<Element>();
  offset? = input<number>(0);

  @HostListener('click', ['$event.target']) onClick(target: HTMLElement) {
    setTimeout(() => {
      let newScrollTop = this.myElement.nativeElement.offsetTop;
      let scrollProperties: ScrollToOptions = {
        behavior: 'smooth',
        top: newScrollTop + this.offset(),
      };
      if (this.scrollToTop()) {
        this.scrollToTop().scrollTo(scrollProperties);
      }
      else {
        window.scrollTo(scrollProperties);
      }
    }, 0);
  };
};
